import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { DateTime } from "luxon";
import { Box } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import { postData, getData } from '../../../webService/webservice.js'
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import "../../../styles/Auth/stockTransfer.css";

const StockTransferPage = ({ filters }) => {
    const [stockTransfers, setstockTransfers] = useState([]);
    const [isAddStockTransfer, setIsAddAddStockTransfer] = useState(false);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setLimit] = useState(5);
    const [totalCount, setTotalCount] = useState(0);
    const sessionToken = sessionStorage.getItem('sessionToken');
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [selectedTransfer, setSelectedTransfer] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const headings = [
        'SL',
        'Product Name',
        "From",
        "To",
        'Transfer Quantity',
        'Remarks',
        'Action',
    ];

    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };


    const fetchProducts = async () => {
        try {
            const token = sessionStorage.getItem("sessionToken");
            const params = {
                productType: "Both",
            };
            const response = await getData('products/products', params, token);
            console.log("API Full Response: ", response);

            const results = response?.data?.[0]?.paginatedResults || [];
            setProducts(results);
        } catch (error) {
            console.error("Failed to fetch Products", error);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);


    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const [formData, setFormData] = useState({
        productId: '',
        fromType: '',
        toType: '',
        transferQuantity: '',
        remarks: ''
    });

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleAddStockTransfer = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const stockTransferData = {
                productId: formData.productId,
                fromType: formData.fromType,
                toType: formData.toType,
                transferQuantity: formData.transferQuantity,
                remarks: formData.remarks
            };

            const response = await postData("/stocktransfers/", stockTransferData, sessionToken);

            toast.success(response.message || "Stock Transfer  added successfully");
            setFormData({
                productId: '',
                fromType: '',
                toType: '',
                transferQuantity: '',
                remarks: ''
            });
            setIsAddAddStockTransfer(false);
            triggerRefresh();
        } catch (error) {
            console.error("❌ Add Purchase Error:", error);
            toast.error(error.message || "Add Purchase Failed");
        } finally {
            setLoading(false);
        }
    };

    const fetchStockTransfer = async (page, limit, searchQuery, filters = {}) => {
        setLoading(true);
        const params = {
            page,
            limit,
            search: searchQuery || "",
        };
        if (filters.startDate) params.startDate = filters.startDate;
        if (filters.endDate) params.endDate = filters.endDate;
        try {
            setLoading(true);
            const response = await getData('stocktransfers/stocktransfers', params, sessionToken);
            const resultsWrapper = response?.data?.[0];
            const stockTransferList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setstockTransfers(stockTransferList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Stock Transfer");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchStockTransfer(currentPage, limit, searchQuery, filters);
    }, [currentPage, limit, refreshKey, searchQuery, filters]);

    const handleViewStockTransfer = async (transfer) => {
        setSelectedTransfer(transfer);
        try {
            // Assuming sessionToken is from sessionStorage
            const sessionToken = sessionStorage.getItem("sessionToken");

            // Fetch data using your getData function
            const response = await getData(`stocktransfers/stocktransfer/${transfer}`, sessionToken);
            setSelectedProduct(response.data);
        } catch (error) {

        }
        setViewModalOpen(true);
    };
    return (
        <div className="stockTransfer-layout">
            <div className="stockTransfer-content">
                <main className="stockTransfer-main">
                    {
                        isAddStockTransfer ? (
                            <div className="add-stockTransfer-form">
                                <form className="stockTransfer-form">
                                    <h3>Add Stock Transfer</h3>
                                    <div className="stockTransfer-form-row">
                                        <div className="stockTransfer-form-group">
                                            <label className="input-label">Choose Product</label>
                                            {loading ? (
                                                <p>Loading products...</p>
                                            ) : (
                                                <select
                                                    className="stockTransfer-input"
                                                    value={formData.productId}
                                                    onChange={(e) =>
                                                        setFormData((prev) => ({ ...prev, productId: e.target.value }))
                                                    }
                                                >
                                                    <option value="">-- Select Product --</option>
                                                    {products.map((product) => (
                                                        <option key={product._id} value={product._id}>
                                                            {product.title}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        </div>

                                        <div className="stockTransfer-form-group">
                                            <label className="input-label">From</label>

                                            <select
                                                className="stockTransfer-input"
                                                required
                                                value={formData.fromType}
                                                onChange={(e) => {
                                                    const selectedfromType = e.target.value;
                                                    setFormData((prev) => ({ ...prev, fromType: selectedfromType }))
                                                }}
                                                disabled={!formData.productId}  // Disable until product is selected
                                            >
                                                <option value=''>Select Type</option>

                                                <option value='Offline'>
                                                    Offline ({selectedProduct?.offlineStock ?? 0} Qty)
                                                </option>

                                                <option value='Online'>
                                                    Online ({selectedProduct?.onlineStock ?? 0} Qty)
                                                </option>
                                            </select>
                                        </div>

                                        <div className="stockTransfer-form-group">
                                            <label className="input-label">To</label>
                                            <select
                                                className="stockTransfer-input"
                                                required
                                                value={formData.toType}
                                                onChange={(e) => {
                                                    const selectedToType = e.target.value;
                                                    setFormData((prev) => ({ ...prev, toType: selectedToType }))
                                                }}
                                            >
                                                <option value=''>Select Type</option>
                                                <option value='Offline'>Offline</option>
                                                <option value='Online'>Online</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="stockTransfer-form-row">
                                        <div className="stockTransfer-form-group">
                                            <label className="input-label">Transfer Quantity</label>
                                            <input
                                                className="stockTransfer-input"
                                                type="number"
                                                required
                                                value={formData.transferQuantity}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        transferQuantity: e.target.value,
                                                    }))
                                                }
                                            />

                                        </div>
                                        <div className="stockTransfer-form-group">
                                            <label className="input-label">Remarks</label>
                                            <input
                                                type="text"
                                                className="stockTransfer-input"
                                                value={formData.remarks}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, remarks: e.target.value }))
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="stockTransfer-buttons">
                                        <button className="add-stockTransfer-button" type="submit" onClick={handleAddStockTransfer}>
                                            Add StockTransfer
                                        </button>
                                        <button className="cancel-stockTransfer-button" onClick={() => setIsAddAddStockTransfer(false)}>
                                            cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        ) : (
                            <>
                                <div className="stockTransfer-widgets">
                                    <div className="stockTransfer-widgets-header">
                                        <h3>stock Exchange</h3>
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="stockTransfer-search-input"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                    </div>
                                    <div className="add-stockTransfer-buttons">
                                        <button className="add-btn-stockTransfer" onClick={() => setIsAddAddStockTransfer(true)} >+ Add New stockTransfer</button>
                                    </div>

                                </div>
                                <TableContainer component={Paper} sx={{
                                    borderRadius: '12px',
                                    maxHeight: 400,
                                    overflowY: "auto",
                                    '&::-webkit-scrollbar': { display: 'none' },
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none',
                                }}>
                                    <Table className="custom-product-table"
                                        sx={{
                                            '& td, & th': {
                                                border: 'none',
                                            },
                                            border: 'none',
                                        }}>
                                        <TableHead className="custom-product-head">
                                            <TableRow>
                                                {headings.map((heading, index) => (
                                                    <TableCell
                                                        key={index}
                                                        sx={{
                                                            border: 'none',
                                                            padding: '12px 16px',
                                                            textAlign: 'center',
                                                            position: "sticky",
                                                            top: 0,
                                                            backgroundColor: '#E6CF80',
                                                            zIndex: 1,
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                gap: '4px',
                                                                color: '#000000',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                            }}
                                                        >
                                                            {heading}
                                                        </Typography>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {stockTransfers.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={headings.length}>
                                                        <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                            No stockTransfers found.
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                stockTransfers.map((stockTransfer, index) => (
                                                    <TableRow key={stockTransfer._id}>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                        </TableCell>
                                                        {/* <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {stockTransfer.stockTransferInvoiceDate
                                                                    ? DateTime.fromISO(stockTransfer.stockTransferInvoiceDate).toFormat("dd LLL yyyy")
                                                                    : "—"}
                                                            </Typography>
                                                        </TableCell> */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {stockTransfer.productDetails?.[0]?.title || "—"}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {stockTransfer.fromType || "—"}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {stockTransfer.toType || "—"}
                                                            </Typography>
                                                        </TableCell>
                                                        {/* <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {stockTransfer.supplierDetails?.[0]?.supplierName || "—"}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {stockTransfer.stockTransferInvoiceNumber || "—"}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {stockTransfer.stockTransferInvoiceAmount || "—"}
                                                            </Typography>
                                                        </TableCell> */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {stockTransfer.transferQuantity || "—"}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {stockTransfer.remarks || "—"}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                                <Icon icon={plusIcon} width={20} height={20} onClick={() => handleViewStockTransfer(stockTransfer)} />
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <div className="stockTransfer-bottom">
                                    <div className="stockTransfer-section show-entries">
                                        <span className="text-label">Show</span>
                                        <select className="entries-select" value={limit}
                                            onChange={handleItemsPerPageChange}
                                        >
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="all">All</option>
                                        </select>
                                        <span className="text-label">Entries</span>
                                    </div>
                                    <div className="purchase-section showing-range">
                                        {
                                            limit === 'all'
                                                ? `Showing all ${totalCount} entries`
                                                : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                        }
                                    </div>
                                    <div className="purchase-section spacer"></div>
                                    <div className="purchase-section pagination-buttons">
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("prev")}
                                        >Previous</button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("next")}
                                        >Next</button>
                                    </div>
                                </div>

                                {limit > 5 && stockTransfers.length > 5 && (
                                    <div className="scroll-down-hint">
                                        <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                            Scroll down to see more stockTransfers
                                        </Typography>
                                    </div>
                                )}

                                {viewModalOpen && selectedTransfer && (
                                    <div className="modal-overlay">
                                        <div className="modal-container">
                                            <h3>Stock Transfer Details</h3>

                                            <div className="modal-content">

                                                <p><strong>Product:</strong> {selectedTransfer.productDetails?.[0]?.title}</p>

                                                <p><strong>From:</strong> {selectedTransfer.fromType}</p>
                                                <p><strong>To:</strong> {selectedTransfer.toType}</p>

                                                <p><strong>Transfer Qty:</strong> {selectedTransfer.transferQuantity}</p>

                                                <p><strong>Remarks:</strong> {selectedTransfer.remarks || "-"}</p>

                                                <p><strong>Date:</strong> {DateTime.fromISO(selectedTransfer.createdAt).toFormat("dd LLL yyyy")}</p>

                                                <p><strong>Online Stock:</strong> {selectedTransfer.productDetails?.[0]?.onlineStock}</p>
                                                <p><strong>Offline Stock:</strong> {selectedTransfer.productDetails?.[0]?.offlineStock}</p>

                                            </div>

                                            <button className="close-btn" onClick={() => setViewModalOpen(false)}>Close</button>
                                        </div>
                                    </div>
                                )}

                            </>
                        )
                    }
                </main>
            </div>
        </div>
    );
};

export default StockTransferPage;